import React, { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, homeFor } from "@/contexts/AuthContext";
import { FullLoader } from "@/components/FullLoader";
import type { Role } from "@/types";

export const ProtectedRoute = ({ roles, children }: { roles: Role[]; children: ReactNode }) => {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to={roles.includes("customer") ? "/login" : "/partner/login"} replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  if (user.role === "customer" && user.temp_password && pathname !== "/app/change-password") return <Navigate to="/app/change-password" replace />;
  if (user.role === "customer" && !user.temp_password && !user.booking_details_set && pathname !== "/app/welcome") {
    if (pathname !== "/app") localStorage.setItem("wn_after_login", pathname + window.location.search);
    return <Navigate to="/app/welcome" replace />;
  }
  return <>{children}</>;
};
